// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__11eAg","active":"NavigationItem_active__3qPeF"};